import type { AppNotification, NotificationSource } from '@zunelo/shared';

export function sortNotificationsNewestFirst(
  notifications: readonly AppNotification[],
): AppNotification[] {
  return [...notifications].sort((left, right) => right.updatedAt.localeCompare(left.updatedAt));
}

export function countUnseenNotifications(
  notifications: readonly AppNotification[],
  seenThrough: string | null,
): number {
  if (!seenThrough) return notifications.length;
  return notifications.filter((notification) => notification.updatedAt > seenThrough).length;
}

export function notificationDestinationLabel(source: NotificationSource): string {
  const labels: Record<NotificationSource, string> = {
    slack: 'Abrir en Mensajes',
    jira: 'Abrir en Tareas',
    github: 'Abrir en Código',
    gmail: 'Abrir en Correo',
    system: 'Ver detalle',
  };
  return labels[source];
}
